import React from 'react';
import { Link } from 'react-router-dom'; 
import { MdKeyboardArrowRight } from 'react-icons/md'; 

const AllClass = () => {
    return (
        <div className="">
            <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-3xl font-semibold mb-4 sm:mb-5 md:mb-6 text-center sm:text-left">
                Classes
            </h1>

            <nav className="text-gray-600 mb-4">
                <ol className="flex flex-wrap items-center space-x-2 text-sm sm:text-base md:text-lg lg:text-xl xl:text-xl">
                    <li>
                        <Link to="/dashboard" className="hover:text-[#ffa404]">
                            Home
                        </Link>
                    </li>
                    <li className="text-[#ffa404]">
                        <MdKeyboardArrowRight size={25} />
                    </li>
                    <li className="text-[#ffa404]">
                        <Link to="/allclass" className="hover:text-[#ffa404]">
                            All Classes
                        </Link>
                    </li>
                </ol>
            </nav>

            <div className="bg-white shadow-md rounded-lg p-6 mt-6 h-[70vh] sm:h-[60vh] md:h-[60vh] lg:h-[70vh] xl:h-[80vh]">
                <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center sm:text-left">All Class Schedules</h2>
                <div className="flex flex-col sm:flex-row sm:space-x-6 justify-center sm:justify-between items-center sm:items-center mb-6 w-full">
                    <input type="text" className="p-2 pl-5 pr-5 rounded bg-gray-100 mb-4 sm:mb-0 w-full sm:w-1/4" placeholder="Search by Name" />

                    <input type="text" className="p-2 pl-5 pr-5 rounded bg-gray-100 mb-4 sm:mb-0 w-full sm:w-1/4" placeholder="Search by Roll" />

                    <input type="text" className="p-2 pl-5 pr-5 rounded bg-gray-100 mb-4 sm:mb-0 w-full sm:w-1/4" placeholder="Search by Class" />

                    <button className="pl-5 pr-5 p-2 bg-[#ffa404] text-white rounded hover:bg-green-600 text-xl w-full sm:w-1/4">SEARCH</button>
                </div>

                <div className="overflow-x-auto">
                    <table className="table-auto w-full border border-gray-300 border-collapse">
                        <thead>
                            <tr className="border-b border-gray-300">
                                <th className="py-2 px-4 text-left text-gray-600">
                                    <input type="checkbox" className="form-check-input" /> Roll
                                </th>
                                <th className="py-2 px-4 text-left text-gray-600">Photo</th>
                                <th className="py-2 px-4 text-left text-gray-600">Name</th>
                                <th className="py-2 px-4 text-left text-gray-600">Gender</th>
                                <th className="py-2 px-4 text-left text-gray-600">Class</th>
                                <th className="py-2 px-4 text-left text-gray-600">Section</th>
                                <th className="py-2 px-4 text-left text-gray-600">Parents</th>
                                <th className="py-2 px-4 text-left text-gray-600">Address</th>
                                <th className="py-2 px-4 text-left text-gray-600">Date of Birth</th>
                                <th className="py-2 px-4 text-left text-gray-600">Phone</th>
                                <th className="py-2 px-4 text-left text-gray-600">E-mail</th>
                                <th className="py-2 px-4 text-left text-gray-600">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="border-b border-gray-300 even:bg-gray-100 odd:bg-white hover:bg-gray-200">
                                <td className="py-2 px-4">
                                    <div className="form-check flex items-center space-x-2">
                                        <input type="checkbox" className="form-check-input" />
                                        <label className="form-check-label">#0021</label>
                                    </div>
                                </td>
                                <td className="py-2 px-4 text-center">
                                    <img src="img/figure/student2.png" alt="student" className="w-12 h-12 object-cover rounded-full" />
                                </td>
                                <td className="py-2 px-4">Mark Willy</td>
                                <td className="py-2 px-4">Male</td>
                                <td className="py-2 px-4">2</td>
                                <td className="py-2 px-4">A</td>
                                <td className="py-2 px-4">Jack Sparrow</td>
                                <td className="py-2 px-4">TA-107 New York</td>
                                <td className="py-2 px-4">02/05/2001</td>
                                <td className="py-2 px-4">+123 9988568</td>
                                <td className="py-2 px-4">kazifahim93@gmail.com</td>
                                <td className="py-2 px-4">
                                    <div className="dropdown">
                                        <button className="dropdown-toggle" aria-expanded="false">
                                            <span className="flaticon-more-button-of-three-dots"></span>
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-right">
                                            <a className="dropdown-item" href="#"><i className="fas fa-times text-orange-red"></i> Close</a>
                                            <a className="dropdown-item" href="#"><i className="fas fa-cogs text-dark-pastel-green"></i> Edit</a>
                                            <a className="dropdown-item" href="#"><i className="fas fa-redo-alt text-orange-peel"></i> Refresh</a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr className="border-b border-gray-300 even:bg-gray-100 odd:bg-white hover:bg-gray-200">
                                <td className="py-2 px-4">
                                    <div className="form-check flex items-center space-x-2">
                                        <input type="checkbox" className="form-check-input" />
                                        <label className="form-check-label">#0022</label>
                                    </div>
                                </td>
                                <td className="py-2 px-4 text-center">
                                    <img src="img/figure/student2.png" alt="student" className="w-12 h-12 object-cover rounded-full" />
                                </td>
                                <td className="py-2 px-4">John Doe</td>
                                <td className="py-2 px-4">Male</td>
                                <td className="py-2 px-4">3</td>
                                <td className="py-2 px-4">B</td>
                                <td className="py-2 px-4">Jane Doe</td>
                                <td className="py-2 px-4">TA-108 Los Angeles</td>
                                <td className="py-2 px-4">03/05/2002</td>
                                <td className="py-2 px-4">+123 9988569</td>
                                <td className="py-2 px-4">johndoe93@gmail.com</td>
                                <td className="py-2 px-4">
                                    <div className="dropdown">
                                        <button className="dropdown-toggle" aria-expanded="false">
                                            <span className="flaticon-more-button-of-three-dots"></span>
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-right">
                                            <a className="dropdown-item" href="#"><i className="fas fa-times text-orange-red"></i> Close</a>
                                            <a className="dropdown-item" href="#"><i className="fas fa-cogs text-dark-pastel-green"></i> Edit</a>
                                            <a className="dropdown-item" href="#"><i className="fas fa-redo-alt text-orange-peel"></i> Refresh</a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>


        </div>
    );
};

export default AllClass;
